import React from 'react';

import Loadable from 'react-loadable';
import { type RouteComponentProps } from 'react-router-dom';

const LazyAgentEmbed = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_async-standalone-directory_agent-embed-page" */ './main'
		),
	loading: () => null,
});
LazyAgentEmbed.displayName = 'lazy(LazyAgentEmbed)';

const AgentEmbedRoute = ({
	match,
}: Pick<RouteComponentProps<{ agentId: string }>, 'match'>): React.JSX.Element => {
	return <LazyAgentEmbed agentId={match.params.agentId} />;
};

export default AgentEmbedRoute;
